import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

/**
 * Scroll-triggered count-up for display stats.
 * Supports values like "$1.3M+", "140%", "2 weeks", "2x", "$880K".
 */
export const CountUp = ({ value, className, style, duration = 1.35 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!inView) return;

    const match = String(value).match(/^([^0-9]*)([\d.]+)(.*)$/);
    if (!match) {
      setDisplay(value);
      return;
    }

    const [, prefix, numStr, suffix] = match;
    const target = parseFloat(numStr);
    const decimals = numStr.includes(".") ? numStr.split(".")[1].length : 0;

    const controls = animate(0, target, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        const n = decimals ? v.toFixed(decimals) : Math.round(v).toString();
        setDisplay(`${prefix}${n}${suffix}`);
      },
    });

    return () => controls.stop();
  }, [inView, value, duration]);

  return (
    <span ref={ref} className={className} style={style}>
      {display}
    </span>
  );
};
